export const LANDING = '/login';
export const HOMEPAGE = '/homepage'
export const DASHBOARD = "/";
export const MAINDASHBOARD = "/main/:id";
export const TEAMSDASHBOARD = "/teams/:id";
export const PERSONALDASHBOARD = "/personal/:id";
export const PROJECTSDASHBOARD = "/projects/:id";
export const BUSINESSDASHBOARD = "/business/:id";
export const WORKSPACE = "/workspace/:id";
export const RESET = '/reset';
export const EMAILUPDATE = '/emailUpdate';
export const PASSWORDUPDATE = '/passwordUpdate';
